export enum LoginRoutes {
  TwoFA = 'two-fa',
}
